import React from 'react';
import { ParallaxImage } from '../ui/ParallaxImage';
export function Hero() {
  return <section className="relative min-h-screen flex flex-col justify-center pt-[60px]" data-id="element-96">
      <div className="absolute inset-0 z-0" data-id="element-97">
        <ParallaxImage src="https://cdn.magicpatterns.com/uploads/jMmha6v8uLEyvnfRq45i36/Screenshot_2026-06-01_at_1.00.58_PM.png" alt="PRT community group photo outside the Gilbert, AZ gym" className="w-full h-full" overlay={false} objectPosition="center 35%" data-id="element-98" />
        {/* Lighter overlays so faces stay visible while text remains legible */}
        <div className="absolute inset-0 bg-prt-darker/30" data-id="element-99" />
        <div className="absolute inset-0 bg-gradient-to-r from-prt-darker/85 via-prt-darker/40 to-transparent" data-id="element-100" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-prt-darker" data-id="element-101" />
      </div>

      <div className="container mx-auto px-6 relative z-10 flex-1 flex flex-col justify-center" data-id="element-102">
        <div className="max-w-3xl" data-id="element-103">
          <span className="text-prt-tan font-semibold tracking-[0.2em] text-sm uppercase mb-4 block drop-shadow-[0_2px_8px_rgba(0,0,0,0.8)]" data-id="element-104">
            Gilbert, AZ
          </span>
          <h1 className="font-heading text-white text-5xl md:text-7xl lg:text-8xl leading-[0.9] mb-6 drop-shadow-[0_4px_16px_rgba(0,0,0,0.7)]" data-id="element-105">
            REALIZE YOUR
            <br data-id="element-106" />
            POTENTIAL.
          </h1>
          <p className="text-white text-lg md:text-xl mb-10 max-w-xl font-medium drop-shadow-[0_2px_8px_rgba(0,0,0,0.9)]" data-id="element-107">
            A community of driven humans. Set goals. Show up. Transform.
          </p>

          <div className="flex flex-col sm:flex-row gap-4" data-id="element-108">
            <button className="bg-prt-blue hover:bg-prt-blue/90 text-white px-8 py-4 rounded font-heading tracking-wider text-xl transition-colors min-h-[48px] w-full sm:w-auto shadow-lg shadow-prt-blue/30" data-id="element-109">
              Get Started
            </button>
            <button className="border-2 border-white hover:bg-white hover:text-prt-darker text-white px-8 py-4 rounded font-heading tracking-wider text-xl transition-colors min-h-[48px] w-full sm:w-auto backdrop-blur-sm bg-white/5" data-id="element-110">
              See Classes
            </button>
          </div>
        </div>
      </div>

      <div className="relative z-10 bg-prt-darker/90 backdrop-blur-sm border-t border-white/10 py-6 mt-auto" data-id="element-111">
        <div className="container mx-auto px-6" data-id="element-112">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-113">
            {[{
            label: '500+',
            sub: 'Members'
          }, {
            label: '10+',
            sub: 'Classes/Week'
          }, {
            label: 'Expert',
            sub: 'Coaches'
          }].map((stat, i) => <div key={i} className="bg-prt-surface border border-prt-blue/30 rounded-full px-8 py-3 flex items-center gap-3 w-full md:w-auto justify-center" data-id="element-114">
                <span className="text-prt-blue font-heading text-2xl" data-id="element-115">
                  {stat.label}
                </span>
                <span className="text-white text-sm uppercase tracking-wider font-medium" data-id="element-116">
                  {stat.sub}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}